import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  filterPaper: {
    color: theme.palette.text.primary,
    padding: theme.spacing(3),
    fontWeight: "400",
    border: "2px solid #dddddd",
  },
  topBanner: {
    color: theme.palette.text.primary,
    fontWeight: "400",
    padding: theme.spacing(2),
    border: "2px solid #dddddd",
    borderRadius: 0,
    backgroundColor: "#F6F6F6",
  },
  treeContainer: {
    display: "flex",
    paddingTop: "10px",
    flexDirection: "column",
    width: "100%",
    height: "280px",
    border: "2px solid #dddddd",
    overflow: "auto",
  },
  buttonContainer: {
    borderTop: "2px solid #dddddd",
    marginTop: "20px",
    paddingTop: "20px",
    paddingBottom: "10px",
  },
  submit: {
    marginRight: "6px",
  },
  cancel: {
    marginLeft: "6px",
  },
  listDiv: {
    marginBottom: "20px",
  },
  listButton: {
    color: "white",
    background: "#64c2de",
    "&:hover": {
      background: "#2891ac",
    },
  },
}));
export default useStyles;
